// Port of api/fuel/app/classes/controller/api/monty/mechanics/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT mechanic_id, mechanic_name FROM mechanic WHERE LOWER(mechanic_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND mechanic_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].mechanic_id] = { id: rows[i].mechanic_id, name: rows[i].mechanic_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
